<template>
  <div
    :class="[`backdrop ${isOpenPaymentInfo ? 'show-backdrop' : ''}`]"
    @click="$emit('on-backdrop-click')"
  >
    <div
      :class="[
        `payment-info-block ${
          isOpenPaymentInfo ? 'open-payment-info-block' : ''
        }`,
      ]"
      @click.stop=""
    >
      <div class="payments-element">
        <img
          v-if="openedCustomer.img"
          :src="openedCustomer.img"
          alt=""
          class="payments-element-image-block"
        />
        <div v-else class="payments-element-image-block">
          <user-icon class="payments-element-image-icon" />
        </div>
        <div class="payments-element-name-block">
          <p class="payments-element-name">{{ openedCustomer.title }}</p>
          <p class="payments-element-date">
            {{ openedCustomer.category.title }}
          </p>
        </div>
        <div class="payments-element-price-block">
          <p
            v-if="openedCustomer.status === 'draw'"
            class="payments-element-price draft"
          >
            {{ $t("homePage.notConfirmed") }}
          </p>
          <p v-else class="payments-element-price">
            {{ $t("homePage.confirmed") }}
          </p>
          <p class="payments-element-price-origin">
            {{ openedCustomer.type.title }}
          </p>
        </div>
      </div>
      <div class="payment-info-list-item">
        <p class="info-list-key">{{ $t("homePage.type") }}</p>
        <p class="info-list-value">{{ openedCustomer.type.title }}</p>
      </div>
      <div class="payment-info-list-item">
        <p class="info-list-key">{{ $t("homePage.category") }}</p>
        <p class="info-list-value">{{ openedCustomer.category.title }}</p>
      </div>
      <div class="payment-info-list-item">
        <p class="info-list-key">{{ $t("homePage.summ") }}</p>
        <p class="info-list-value info-plist-price">
          {{
            `${returnCurrencySymbol(openedCustomer.currency) || ""}${
              openedCustomer.sum
            }`
          }}
        </p>
      </div>
      <div class="payment-info-list-item">
        <p class="info-list-key">{{ $t("homePage.title") }}</p>
        <p class="info-list-value">{{ openedCustomer.title }}</p>
      </div>
      <button
        class="close-info-customer-modal"
        @click="$emit('on-backdrop-click')"
      >
        {{ $t("analytics.returnButton") }}
      </button>
      <div class="change-operation-container">
        <button class="change-operation-button edit" @click="setEditOperation">
          {{ $t("category.edit") }}
        </button>
        <button
          class="change-operation-button delete"
          @click="setDeleteOperation"
        >
          {{ $t("homePage.deleteOperation") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { UserIcon } from "vue-feather-icons";
import { mapMutations } from "vuex";

export default {
  name: "Payments-info-page",
  components: {
    UserIcon,
  },
  props: {
    isOpenPaymentInfo: {
      type: Boolean,
      require: true,
    },
    openedCustomer: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      currencySymbol: {
        1: "₴",
        2: "$",
        4: "€",
        6: "zł",
        7: "₴",
      },
    };
  },
  async mounted() {},

  methods: {
    ...mapMutations(["deleteOperationById"]),
    setDeleteOperation() {
      this.$emit("on-open-question-block");
    },
    setEditOperation() {
      this.$emit("on-backdrop-click");
      this.$emit("is-change-edit-module", true);
    },
    returnCurrencySymbol(currency) {
      if (this.currencySymbol[currency.id]) {
        return this.currencySymbol[currency.id];
      } else {
        return currency.code_alfa;
      }
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
.payment-info-block {
  position: absolute;
  width: 95%;
  left: 2.5%;
  bottom: 2.5%;
  padding: 15px;
  padding-top: 80px;
  transform: translateY(110%);
  pointer-events: all !important;
  -webkit-backdrop-filter: saturate(180%) blur(80px);
  backdrop-filter: saturate(180%) blur(80px);
  background-color: rgba(255, 255, 255, 0.8);
  pointer-events: none;
  z-index: 9999 !important;
  border: 0px !important;
  border-radius: 20px;
  transition: all 0.5s ease;
}

.open-payment-info-block {
  transform: none;
}

.payments-element {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  text-decoration: none;
  cursor: pointer;
}

.payments-element:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.payments-element-image-block {
  width: 45px;
  height: 45px;
  border-radius: 15px;
  background-image: var(--main-bg-color);
  display: flex;
  margin-right: 10px;
}

.payments-element-image-icon {
  color: #fff;
  margin: auto;
  width: 25px;
}

.payments-element-name {
  font-family: "Source Sans Pro", sans-serif;
  color: #1b1b1b;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  margin-bottom: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 250px;
}

.payments-element-date {
  color: #747474;
  margin-bottom: 30px;
  letter-spacing: -0.2px;
  font-size: 11px;
  opacity: 0.7;
  margin-bottom: 0px;
  line-height: 12px;
}
.payments-element-name-block {
  padding-top: 4px;
}

.payments-element-price-block {
  margin-left: auto;
  padding-top: 4px;
}

.payments-element-price {
  margin-bottom: 0px;
  color: #8cc152;
  font-size: 13px;
  line-height: 23px;
  font-weight: 700;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: -0.6px;
  text-align: end;
  text-transform: uppercase;
}

.payments-element-price.draft {
  color: #f6bb42;
}

.payments-element-price-origin {
  margin-bottom: 0px;
  font-size: 11px;
  color: #747474;
  padding-bottom: 0px;
  letter-spacing: -0.2px;
  text-align: right;
  line-height: 12px;
}

.close-info-customer-modal {
  display: block;
  font-family: "Source Sans Pro", sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 12px;
  font-size: 13px;
  padding: 14px 20px;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.1);
  transition: all 120ms ease;
  background-size: cover;
  position: relative;
  z-index: 10;
  background-image: var(--main-bg-color);
  color: #fff;
  width: 100%;
  border: none;
  margin-top: 20px;
  cursor: pointer;
  margin-bottom: 20px;
}

.close-info-customer-modal::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.8) translateY(5px) translateZ(0px);
  filter: blur(12px);
}

.payment-info-list-item {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.info-list-key {
  margin: 0;
  color: #0f1117;
  font-size: 13px;
  font-family: "Roboto", sans-serif;
  line-height: 24px;
  font-weight: bolder;
}

.info-list-value {
  margin: 0;
  color: #747474;
  font-size: 13px;
  font-family: "Roboto", sans-serif;
  line-height: 24px;
  font-weight: bolder;
}

.info-plist-price {
  color: #4a89dc;
}

.change-operation-container {
  display: flex;
  justify-content: space-between;
}

.change-operation-button {
  position: relative;
  font-family: "Source Sans Pro", sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 12px;
  font-size: 13px;
  padding: 14px 20px;
  width: 50%;
  color: #fff;
  font-size: 12px;
  padding: 12px 18px;
  border: none;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.1);
  transition: all 120ms ease;
  cursor: pointer;
}
.change-operation-button.edit {
  margin-right: 10px;
  background-image: var(--main-bg-color);
}
.change-operation-button.delete {
  margin-left: 10px;
  background-image: linear-gradient(to bottom, #ed5565, #d84558);
}
.change-operation-button::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.75) translateY(5px) translateZ(0px);
  filter: blur(8px);
}
</style>
